<template>
  <div >
    <div style="white-space: pre-line;padding: 10px" v-html="informationHeader"></div>
        <div style="width: 96%;margin:2%;" v-show="showTaskInformation" v-loading="loading">
          <analyze-info :project-id="projectId" :analyze-id="analyzeId" v-if="projectId" ></analyze-info>
        </div>
  </div>

</template>

<script>
import {fileDownload} from "@/utils/utils";
import {getDataInSessionStorage} from "@/utils/sessionStorage";
import AnalyzeInfo from '@/components/AnalyzeInfo'

export default {
  name: "AnalyzeInformation",
  components: {'analyze-info':AnalyzeInfo},
  created() {
    this.index = this.$route.query.index
    this.analyzeId = this.$route.query.analyzeId
    this.projectId = this.$route.query.projectId
    if(this.index==='99'){
      this.informationProject=true
      this.getAnalyzeDetail();
    }
  },
  data() {
    return {
      state: '',
      loading:true,
      informationHeader:'',
      index:'',
      showInYes: true,
      showTaskInformation: true,
      fileNames: [],
      submitTime: '',
      analyzeData: {
       param:{
         otuMinTime:'',
         otuMinPercent:''
       }
      },
      informationProject:false,
    }
  },
  methods: {
    controlTaskInformation() {
      this.showTaskInformation = !this.showTaskInformation
      this.showInYes = !this.showInYes
    },
    async getAnalyzeDetail() {
      const res = await this.$http.get('analyze/info/' + this.analyzeId)
      if (res.code === 200) {
        this.analyzeData = res.data
        this.projectId = res.data.projectId
        this.state = res.data.execStatus
        this.fileNames=res.data.files
        this.get()
      }
    },
 get() {
      for (let index in this.fileNames) {
        this.names += this.fileNames[index] + "\n"
      }
      this.loading=false
    },
  },
}
</script>

<style scoped>
.el-card /deep/ .el-card__header {
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  padding: 0px;
}
.el-descriptions /deep/.el-descriptions-item__label {
  /*background: #f8f7f7;*/
  color: #7e7d7d;
}
</style>

